// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stack {
  display: flex;
  flex-direction: column;
}
.stack.spacing-4px > :not(:first-child) {
  margin-top: 4px;
}
.stack.spacing-8px > :not(:first-child) {
  margin-top: 8px;
}
.stack.spacing-12px > :not(:first-child) {
  margin-top: 12px;
}
.stack.spacing-16px > :not(:first-child) {
  margin-top: 16px;
}
.stack.spacing-32px > :not(:first-child) {
  margin-top: 32px;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Stack.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAEI;EACI,eAAA;AAAR;AAII;EACE,eAAA;AAFN;AAMI;EACE,gBAAA;AAJN;AAQI;EACE,gBAAA;AANN;AAUI;EACE,gBAAA;AARN","sourcesContent":[".stack {\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  &.spacing-4px{\r\n    > :not(:first-child) {\r\n        margin-top: 4px;\r\n    }\r\n  }\r\n  &.spacing-8px{\r\n    > :not(:first-child) {\r\n      margin-top: 8px;\r\n    }\r\n  }\r\n  &.spacing-12px{\r\n    > :not(:first-child) {\r\n      margin-top: 12px;\r\n    }\r\n  }\r\n  &.spacing-16px{\r\n    > :not(:first-child) {\r\n      margin-top: 16px;\r\n    }\r\n  }\r\n  &.spacing-32px{\r\n    > :not(:first-child) {\r\n      margin-top: 32px;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
